import {inject, Injectable} from '../di';
import {AppInitializeService} from '../app-initialize-service';
import {I18nService} from './i18n-service';
import {Logger} from '../logger';
import {skip} from 'rxjs';

@Injectable()
export class LocalizedStylesService implements AppInitializeService {
  private readonly logger = inject(Logger);
  private readonly i18nService = inject(I18nService);

  /**
   * Locales available in `s/locales` folder.
   */
  private readonly localeStyles = [`uk`, `es`, `ru`, `fr`, `en`, 'en-US', `de`, `tr`, `zh`, `ar`];

  private loadedLocale: string | undefined = undefined;

  public init() {
    try {
      this.i18nService.localeFallbackChain$.pipe(skip(1)).subscribe(() => this.loadLocaleStyle());
      this.loadLocaleStyle();
      return Promise.resolve(true);
    } catch (err) {
      this.logger.error('[LocalizedStylesService] Unable to load locale style file', err);
      return Promise.resolve(false);
    }
  }

  private loadLocaleStyle() {
    const locale = this.i18nService.getMostApplicableLocale(this.localeStyles);
    if (locale === this.loadedLocale) {
      return;
    }
    $(document.head).find('#style_lang').remove();
    window.css_append(`s/locales/${locale}.css`, 'style_lang');
  }
}
